// Helper pour formater une durée en secondes en mm:ss
export function formatDuration(seconds: number): string {
  if (!seconds || seconds < 1) return "-";
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}m${s.toString().padStart(2, "0")}s`;
}

// Retourne la date courante au format YYYY-MM-DD
export function currentDate(): string {
  const now = new Date();
  return now.toISOString().split("T")[0];
}
